<template>
  <section class="delivery-score">
    <h5 class="delivery-score__title data-title">deliverability score</h5>

    <div class="delivery-score__content">
      <div class="delivery-score__meter-section">
        <div class="delivery-score__meter">
          <span class="delivery-score__meter-gauge" :style="{ left: finalScore + '%' }"></span>
        </div>
        <div :class="['status-text', status.class]">{{ status.text }}</div>
      </div>

      <ul v-if="suggestions && suggestions.length" class="delivery-score__suggestions-list">
        <li
            v-for="suggestion in suggestions"
            class="delivery-score__suggestion">
          {{suggestion}}
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  import '../../../../assets/javascripts/includes/deliverabilityScore'
  import {mapState} from 'vuex'
  import {isNil} from "../../utilities";

  const deliveryStatuses = [
    {
      appliesTo: (score) => isNil(score),
      text: '',
      class: ''
    }, {
      appliesTo: (score) => score < 69,
      text: 'poor',
      class: 'negative'
    }, {
      appliesTo: (score) => score >= 69 && score <= 89,
      text: 'good',
      class: 'positive'
    }, {
      appliesTo: (score) => score > 89,
      text: 'excellent',
      class: 'positive'
    }
  ];

  export default {
    props: {
      messageModuleName: {
        default: 'message',
        type: String
      },
    },

    name: 'DeliverabilityScore',

    data() {
      return {
        deliveryScore: null,
      }
    },

    computed: {
      finalScore: function () {
        return this.deliveryScore?.deliveryScore
      },

      status() {
        return deliveryStatuses.find(status => status.appliesTo(this.finalScore))
      },

      suggestions: function () {
        return this.getSuggestions()
      },

      ...mapState({
        updatedSmsContent (state) { return state[this.messageModuleName]?.updatedSmsContent },
        blacklistedTerms (state) { return state.blacklistedTerms },
        substitutions (state) { return state.substitutions }
      }),
    },

    methods: {
      getSuggestions() {
        if (this.deliveryScore) {
          let suggestions = []
          for (let key in this.deliveryScore) {
            !!this.deliveryScore[key]?.suggestion && suggestions.push(this.deliveryScore[key].suggestion)
          }
          return suggestions
        }
      },

      setDeliveryScores() {

        this.deliveryScore = buildDeliveryScores({
          textToAnalyze: this.updatedSmsContent,
          nonoList: this.blacklistedTerms,
          substitutions: this.substitutions
        });
      },
    },

    created() {
      this.setDeliveryScores()
    },

    watch: {
      updatedSmsContent: function () {
        this.setDeliveryScores()
      },

      blacklistedTerms: function () {
        this.setDeliveryScores()
      }
    },
  }
</script>
